import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EpcProjectModel } from '../../../../models/epc-project.model';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EpcService } from '../../../../services/epc.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'smart-project-form',
  templateUrl: './project-form.component.html',
  styleUrls: ['./project-form.component.scss'],
})
export class ProjectFormComponent implements OnInit {

  projectForm: FormGroup;

  loadedProject: EpcProjectModel = new EpcProjectModel();

  doAfterEnd: () => void;

  @ViewChild('staticModal', { static: false }) modal: ModalDirective;

  @Output() wasDeleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    protected epcService: EpcService,
    protected toastr: ToastrService,
  ) {
  }

  ngOnInit() {
  }

  generateForm() {
    this.projectForm = this.formBuilder.group({
      agencyCode: [this.loadedProject.agencyCode || '', [Validators.required]],
      agencyName: [this.loadedProject.agencyName || '', [Validators.required]],
      grantNumber: [this.loadedProject.grantNumber || '', [Validators.required]],
      isLocked: [this.loadedProject.isLocked || false, [Validators.required]],
      name: [this.loadedProject.name || '', [Validators.required]],
    });

  }

  openModal(
    project: EpcProjectModel = null,
    doAfterEnd: () => void = null
  ) {
    if (project) {
      this.loadedProject = project;
    }
    this.doAfterEnd = doAfterEnd;
    this.generateForm();
    setTimeout(() => {
      this.modal.show();
    }, 100);
  }

  close(skipAfterEndFn = false) {
    if (this.doAfterEnd && !skipAfterEndFn) {
      this.doAfterEnd();
    }
    this.modal.hide();
  }

  async submitAction() {
    await this.send();
  }

  closeAction() {
    this.close(true);
  }

  async deleteAction() {
    const res = await this.epcService
      .deleteProject(this.loadedProject).toPromise();

    if (!res) {
      console.log(res);
      this.toastr.error('Nastala chyba.');
      return;
    }

    if (res) {
      this.wasDeleted.emit(true);
      this.toastr.success('Projekt bol úspešne zmazaný.');
      this.close();
    }
  }

  async send() {
    const isEditing = (this.loadedProject && this.loadedProject.id !== null && this.loadedProject.id > 0);

    const data = new EpcProjectModel();
    let res;

    if (isEditing) {
      Object.assign(data, this.loadedProject);
      Object.assign(data, this.projectForm.value);
      res = await this.epcService
        .updateProject(data)
        .toPromise();
    } else {
      Object.assign(data, this.projectForm.value);
      res = await this.epcService
        .createProject(data)
        .toPromise();
    }

    if (!res) {
      console.log(res);
      this.toastr.error('Nastala chyba.');
      return;
    }

    this.toastr.success('Projekt bol úspešne uložený / upravený.');
    this.close();
  }


}
